import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { ISalesPipelineModel, ISalesPipelineSettingsModel, ISalesTicketAutoCreateSettingsModel, ISalesTicketSourceModel } from "@models";

@Injectable()
export class SalesPipelinesService {
    constructor(private httpService: HttpService) { }

    // Everything the settings page needs in one call — pipelines with their columns, the source list,
    // and the funnel positions a column can be mapped to. Includes inactive rows so they can be
    // re-enabled.
    async getSettings(): Promise<ISalesPipelineSettingsModel> {
        return await this.httpService.get("/salesPipelines/getSettings");
    }

    // Active pipelines only — what the board's picker offers.
    async getPipelines(): Promise<ISalesPipelineModel[]> {
        return await this.httpService.get("/salesPipelines/getPipelines");
    }

    async getPipeline(salesPipelineId: number): Promise<ISalesPipelineModel> {
        return await this.httpService.get("/salesPipelines/getPipeline", { salesPipelineId });
    }

    async getDefaultPipeline(): Promise<ISalesPipelineModel> {
        return await this.httpService.get("/salesPipelines/getDefaultPipeline");
    }

    async savePipeline(model: ISalesPipelineModel): Promise<ISalesPipelineModel> {
        return await this.httpService.post("/salesPipelines/savePipeline", model);
    }

    async deletePipeline(salesPipelineId: number): Promise<void> {
        return await this.httpService.post(`/salesPipelines/deletePipeline?salesPipelineId=${salesPipelineId}`, {});
    }

    async getSources(includeInactive: boolean = false): Promise<ISalesTicketSourceModel[]> {
        return await this.httpService.get("/salesPipelines/getSources", { includeInactive });
    }

    async saveSource(model: ISalesTicketSourceModel): Promise<ISalesTicketSourceModel> {
        return await this.httpService.post("/salesPipelines/saveSource", model);
    }

    async deleteSource(salesTicketSourceId: number): Promise<void> {
        return await this.httpService.post(`/salesPipelines/deleteSource?salesTicketSourceId=${salesTicketSourceId}`, {});
    }

    async saveAutoCreateSettings(model: ISalesTicketAutoCreateSettingsModel): Promise<void> {
        return await this.httpService.post("/salesPipelines/saveAutoCreateSettings", model);
    }
}
